export default __webpack_public_path__ + "static/media/logo.2c2d40b4.png";